import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-for-student',
  templateUrl: './for-student.component.html',
  styleUrls: ['./for-student.component.scss']
})
export class ForStudentComponent implements OnInit {
  
  user_role:any
  events_list =[]
  imgUrl = environment.apiUrls.course_imageUrl
  isApproved :any
  constructor(public apiService: ApiService,
    private spinner: NgxSpinnerService,private modalService: NgbModal,
    public toastr: ToastrService,private route: Router) {
    this.user_role = JSON.parse(localStorage.getItem('user'))
  }

  ngOnInit(): void {
    this.getAllEvents()
    
  }
  getAllEvents() {
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getEventListStatus(1, 100).subscribe((res: any) => {
      this.spinner.hide();
      this.events_list = res.data.items
    })
  }
  participateEvent(id) {
    let body={
      participants : [this.user_role.id]
    }    
    this.apiService.updateEventParticipant(id,body).subscribe((res:any)=>{
      if(res.statusCode===200){
        this.toastr.success('participate request successfull!')
        this.getAllEvents()
      }
      else{
        this.toastr.error(res.error)
      }
    })
  }
  download(event_id:any){
    this.apiService.getApprovedStudent(this.user_role.id,event_id).subscribe((res:any)=>{
      let data = res?.data?.pdf_link
      window.open(data,'_blank')      
    })
  }
  isApprovedByUser(event, userId) {
    if (event && event.approved_by) {
      return event.approved_by.some(approval => approval._id === userId);
    }
    return false;
  }
  isParticiapteByUser(event, userId) {
    if (event && event.participants) {
      return event.participants.some(approval => approval._id === userId);
    }
    return false;
  }
  openModal(content){
    const modalOptions: NgbModalOptions = {
      size: 'lg' 
    };
    const modalRef = this.modalService.open(content,modalOptions);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  openLms(id){
    window.open(`/event-lms?id=${id}`, '_blank');
  }
}
